// removed by extract-text-webpack-plugin
module.exports = {"contactWrapper":"_3_PHi6ZwRwEXUSWbPhR4Aa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/ContactWrapper/ContactWrapper.scss
// module id = 1714
// module chunks = 0